import api from "./api";

/** Contexto mínimo que la página de postventa muestra al cliente (RF-5). */
export interface PostSaleContext {
  ok: boolean;
  /** Primer nombre del cliente, para el saludo. */
  name?: string;
  testimonialSubmitted?: boolean;
  referralCount?: number;
}

export interface TestimonialInput {
  text: string;
  allowPublish: boolean;
  /** Imagen de prueba como dataURL; el backend la sube a R2. */
  image?: string;
}

export interface ReferralInput {
  name: string;
  phone: string;
  email?: string;
  company?: string;
}

/**
 * Captura pública de postventa (HU-20): el cliente abre la página desde el
 * enlace del correo y deja su testimonio y/o un referido, identificado por el
 * token de la cotización.
 */
class PostSaleService {
  async getContext(token: string): Promise<PostSaleContext> {
    const response = await api.get(`/postventa/${encodeURIComponent(token)}`);
    return response.data;
  }

  async submitTestimonial(
    token: string,
    input: TestimonialInput
  ): Promise<{ ok: boolean }> {
    const response = await api.post(
      `/postventa/${encodeURIComponent(token)}/testimonial`,
      input
    );
    return response.data;
  }

  async submitReferral(
    token: string,
    input: ReferralInput
  ): Promise<{ ok: boolean }> {
    const response = await api.post(
      `/postventa/${encodeURIComponent(token)}/referral`,
      input
    );
    return response.data;
  }
}

export default new PostSaleService();
